declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_bidi_doubing_right_part_with_same_default_foo extends $mol_object {
		b( next?: boolean ): boolean
		a( next?: ReturnType< $mol_view_tree2_to_js_test_ex_bidi_doubing_right_part_with_same_default_foo['b'] > ): ReturnType< $mol_view_tree2_to_js_test_ex_bidi_doubing_right_part_with_same_default_foo['b'] >
		c( next?: ReturnType< $mol_view_tree2_to_js_test_ex_bidi_doubing_right_part_with_same_default_foo['b'] > ): ReturnType< $mol_view_tree2_to_js_test_ex_bidi_doubing_right_part_with_same_default_foo['b'] >
	}
	
}

//# sourceMappingURL=bidi_doubing_right_part_with_same_default.view.tree.d.ts.map